import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["dividers", "sortable", "sorted"];
import React from 'react';
import { node, oneOf, string, bool } from 'prop-types';
import { TableCell as MuiTableCell } from '@material-ui/core';
import useTableCellStyles from './TableCell.styles';
function TableCell(props) {
  const {
      dividers,
      sortable,
      sorted
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const classes = useTableCellStyles({
    dividers,
    sortable,
    sorted
  });
  return /*#__PURE__*/React.createElement(MuiTableCell, Object.assign({}, otherProps, {
    classes: classes
  }));
}
TableCell.propTypes = {
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   */
  align: oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  /**
   * The table cell contents.
   */
  children: node,
  /**
   * @ignore
   */
  className: string,
  /**
   * If the cell should have a bottom border or not.
   */
  dividers: bool,
  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value (`default`).
   */
  padding: oneOf(['default', 'checkbox', 'none']),
  /**
   * Set scope attribute.
   */
  scope: string,
  /**
   * Specify the size of the cell.
   * By default, the Table parent component set the value (`medium`).
   */
  size: oneOf(['small', 'medium']),
  /**
   * If the column that this cell represents can be sorted or not.
   *
   */
  sortable: bool,
  /**
   * Set aria-sort direction.
   */
  sortDirection: oneOf(['asc', 'desc', false]),
  /**
   * If true, the table is currently being sorted by the column this cell represents.
   */
  sorted: bool,
  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: oneOf(['head', 'body', 'footer'])
};
export default TableCell;